import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumbs.scss";
import { getLocalizedValueSync } from "../../services/localizationService";

interface BreadcrumbProps {
  current: string;
}

const Breadcrumbs = ({ current }: BreadcrumbProps) => {
  const location = useLocation();
  const stat = location.state || {};
  const previousPath = location.state?.from;
  const localizedDashboard = getLocalizedValueSync("CA.Dashboard.breadcrumb") || "";

  // Map your route paths to breadcrumb labels
  const routeLabelMap: Record<string, string> = {
    "/": "Home",
    "/dashboard": "Home",
    "/business": "Business",
    "/academy": "Academy",
    "/agronomy": "Agronomy",
    "/marketing": "Marketing",
    "/announcements": "Announcements",
    "/academy-calendar": "Academy Calendar",
    "/keydate-deadlines": "Key Date Deadline",
    "/contacts": "Key Contact Information",
    "/search-results": "Search Results",
    "/my-documents": "My Documents",
  };

  const sanitizeUrl = (url: string) => {
    if (url === undefined) return "";
    return url
      .trim()
      .replace(/[^a-zA-Z0-9-]/g, " ")
      .replace(/\s+/g, "-")
      .toLocaleLowerCase();
  };

  const previousLabel = previousPath
    ? routeLabelMap[previousPath] || previousPath
    : null;

  return (
    <div className="breadcrumb-container" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {current === "Home" ? (
          <>
          <li className="breadcrumb-item">
            <span className="fa-kit fa-home" aria-label="Home"></span>
          </li>
          <li className="breadcrumb-item">
              <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
              <span className="breadcrumb-current" aria-current="page" aria-label={localizedDashboard}>
                {localizedDashboard}
              </span>
            </li>
            </>
        ) : previousLabel === "Home" ? (
          <>
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link" aria-label="Home">
                <span className="fa-kit fa-home"></span>
              </Link>
            </li>
            <li className="breadcrumb-item">
              <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
              <span className="breadcrumb-current" aria-current="page" aria-label={current}>
                {current}
              </span>
            </li>
          </>
        ) : stat.stateData !== undefined ? (
          <>
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link" aria-label="Home">
                <span className="fa-kit fa-home"></span>
              </Link>
            </li>
            {stat.stateData.resourceType && (
              <li className="breadcrumb-item">
                <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
                <Link
                  to={`/${sanitizeUrl(stat.stateData.resourceType)}`}
                  // to={ stat.stateData.resourcePageUrl}
                  className="breadcrumb-link"
                  aria-label={routeLabelMap[
                    `/${sanitizeUrl(stat.stateData.resourceType)}`
                  ] || stat.stateData.resourceType}
                >
                  {routeLabelMap[
                    `/${sanitizeUrl(stat.stateData.resourceType)}`
                  ] || stat.stateData.resourceType}
                </Link>
              </li>
            )}

            <li className="breadcrumb-item">
              <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
              <span className="breadcrumb-current" aria-current="page" aria-label={current}>
                {current}
              </span>
            </li>
          </>
        ) : (
          <>
            <li className="breadcrumb-item">
              <Link to="/" className="breadcrumb-link" aria-label="Home">
                <span className="fa-kit fa-home"></span>
              </Link>
            </li>
            {previousPath && (
              <li className="breadcrumb-item">
                <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
                <Link to={previousPath} className="breadcrumb-link" aria-label={previousLabel}>
                  {previousLabel}
                </Link>
              </li>
            )}

            <li className="breadcrumb-item">
              <span className="breadcrumb-separator fa-kit fa-chevron-small-right"></span>
              <span className="breadcrumb-current" aria-current="page" aria-label={current}>
                {current}
              </span>
            </li>
          </>
        )}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
